import React from "react";
import { useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { useSelector } from "react-redux";
import SideBarSkeleton from "../../Component/SideBarSkeleton";
import { imageUrl } from "../../config/apiUrl";
import { BrandCard2, DemoProfile } from "../../constant/imagePath";
import ChangePassModal from "../../modals/ChangePassModal";
import EditProfileModal from "../../modals/EditProfileModal";
import classes from "./MyProfile.module.css";
const MyProfile = () => {
  const [show, setShow] = useState(false);
  const { user } = useSelector((state) => state.authReducer);

  return (
    <SideBarSkeleton>
      <Container className={`custom_conti_b`}>
        <Row>
          <Col md={5} sm={12} className={classes.main}>
            <div className={classes.card_main}>
              <div className={classes.card_header}></div>
              <div className={classes.card_profile_icon_etc}>
                <h3>My Profile</h3>
                <div className={classes.img_div}>
                  <img
                    src={imageUrl(user?.photo)}
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.src = DemoProfile;
                    }}
                  />
                </div>
                <h5>{user?.userName}</h5>
              </div>
              <div className={classes.card_detail_div}>
                <div>
                  <h5>
                    <span>Email : </span>
                    {user?.email}{" "}
                  </h5>
                </div>
                {/* {!!user?.instagramId && (
                  <div>
                    <h5>
                      <span>Instagram Id : </span>
                      {user?.instagramId}{" "}
                    </h5>
                  </div>
                )} */}
              </div>
              <div className={classes.change_pass_text}>
                <p onClick={() => setShow("edit_profile")}>Edit Profile</p>
                <p onClick={() => setShow(true)}>Change Password</p>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
      {show && <ChangePassModal show={show} setShow={setShow} />}
      {show == "edit_profile" && (
        <EditProfileModal show={show == "edit_profile"} setShow={setShow} />
      )}
    </SideBarSkeleton>
  );
};

export default MyProfile;
